export default __webpack_public_path__ + "images/96ae5aed37276e2bd060bcace0af67db-mysticism.jpg";